export const BASE_CIE_PATH = 'cie'

export enum CIE_ALLOWED_PATH {
  CALLBACK = 'callback',
  CIE_OVERVIEW = 'overview',
  AUDIENCE_PROFILER = 'audience-profiler',
  STORIES = 'stories',
  STORIES_OVERVIEW = 'stories/overview',
  TABLE_OF_CONTENTS = 'table-of-contents',
}

export const isAllowedCiePath = (ciePath: string) => {
  return ciePath.includes(BASE_CIE_PATH)
}

export const getBaseCiePathDefinition = (): string => {
  return `/`
}

export const getCiePathDefinition = (ciePath: CIE_ALLOWED_PATH | string): string => {
  return `/${ciePath}`
}

export const getRetailPathForHistory = (ciePath: CIE_ALLOWED_PATH): string => {
  return ciePath
}

export const getWildcardCiePath = (): string => {
  return '/:page'
}

export const getNewronLogoutPath = (): string => {
  return '/logout'
}

export const isCIERoute = (): boolean => {
  return window.location.pathname.includes(BASE_CIE_PATH) && window.location.pathname !== '/cie/'
}

// New: central helper to strip the /cie basename from a pathname
export const stripCieBase = (path: string): string => {
  const prefix = `/${BASE_CIE_PATH}`
  return path.startsWith(prefix) ? path.substring(prefix.length) || '/' : path
}
